<template>
    <div>
        <menu-datos @getData="getData" v-if="desde==1"/>
        <menu-alarmas :available_alarms="available_alarms" :available_sections="available_sections" @getData="getAlarms" v-if="desde==2"/>
    </div>
</template>
<script>
import MenuAlarmas from './MenuAlarmas.vue';
import MenuDatos from './MenuDatos.vue';



export default {
  components: { MenuDatos, MenuAlarmas },
     
    methods: {
        getData(payload) {
            this.$emit('getData',payload)
            console.log(payload);
        },getAlarms(payload) {
            this.$emit('getAlarms',payload)
            console.log(payload);
        },
    },
    props: {
        'desde': Number,
        
        available_alarms: [],
        available_sections: []
    
    },
    

    
}
</script>
<style lang="">
    
</style>